export function normaliseOrgNumber(input) {
    if (typeof input !== "string")
        return null;
    const digits = input.replace(/[\s+-]/g, "");
    if (!/^\d+$/.test(digits))
        return null;
    let ten;
    if (digits.length === 10)
        ten = digits;
    else if (digits.length === 12 && /^(16|19|20)/.test(digits)) {
        ten = digits.slice(2);
    }
    else
        return null;
    return luhnValid(ten) ? ten : null;
}
export function formatOrgNumber(ten) {
    return ten.length === 10 ? `${ten.slice(0, 6)}-${ten.slice(6)}` : ten;
}
function luhnValid(digits) {
    let sum = 0;
    for (let i = 0; i < digits.length; i++) {
        let d = digits.charCodeAt(i) - 48;
        if (i % 2 === 0) {
            d *= 2;
            if (d > 9)
                d -= 9;
        }
        sum += d;
    }
    return sum % 10 === 0;
}
export function normalisePostcode(input) {
    if (typeof input !== "string")
        return null;
    const digits = input.replace(/\s/g, "");
    return /^\d{5}$/.test(digits) ? digits : null;
}
export function formatPostcode(five) {
    return five.length === 5 ? `${five.slice(0, 3)} ${five.slice(3)}` : five;
}
export const APPLICATION_LIMITS = {
    companyName: 200,
    attention: 200,
    street: 200,
    city: 100,
    contactEmail: 254,
};
